export const lsf = [
    {
        "type": "radiogroup",
        "name": "LSATIS4_A",
        "title": "In general, how satisfied are you with your life? Are you very satisfied, satisfied, dissatisfied, or very dissatisfied?",
        "isRequired": true,
        "choices": [
          { "value": 1, "text": "Very satisfied" },
          { "value": 2, "text": "Satisfied" },
          { "value": 3, "text": "Dissatisfied" },
          { "value": 4, "text": "Very dissatisfied" },
          { "value": 7, "text": "Refused" },
          { "value": 9, "text": "Don't Know" }
        ]
      }
]
